import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { environment } from '../environments/environment';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, CommonModule],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'Backoffice Interno';

  ngOnInit() {
    console.log(
      `Ambiente carregado: ${
        environment.baseURL.includes('homol')
          ? 'HOMOLOGAÇÃO'
          : environment.baseURL.includes('canvi.com.br')
          ? 'PRODUÇÃO'
          : 'PADRÃO'
      }`
    );
  }
}
